import { FormControl, FormControlLabel, FormHelperText, Switch as SwitchMui } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

function Switch({ name, checked, onChange, label, helperText, error, ...controlProps }) {
    return (
        <FormControl error={error}>
            <FormControlLabel
                control={
                    <SwitchMui
                        checked={Boolean(checked)}
                        onChange={(event) => onChange(event.target.checked)}
                        name={name}
                        {...controlProps}
                    />
                }
                label={label}
            />
            <FormHelperText>{helperText}</FormHelperText>
        </FormControl>
    );
}

Switch.propTypes = {
    name: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.string,
    error: PropTypes.bool,
    helperText: PropTypes.string,
};

export default Switch;
